import script from "./ModificarGrupos.vue?vue&type=script&setup=true&lang=js"
export * from "./ModificarGrupos.vue?vue&type=script&setup=true&lang=js"

import "./ModificarGrupos.vue?vue&type=style&index=0&id=9efaf9e2&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9efaf9e2"]])

export default __exports__